import Modal from 'react-bootstrap/Modal'
import Button from "react-bootstrap/Button";
import { confirmModelSelector } from '../../../hooks/store/getters';
import { useAppStore } from '../../../hooks/store/useAppStore';
import { setConfirmModelSelector } from '../../../hooks/store/setters';

const ConfirmModel = () => {
    const confirmModel = useAppStore(confirmModelSelector);
    const setConfirmModel = useAppStore(setConfirmModelSelector);


    const { title, text, show, successCallback, cancelButtonText, successButtonText } = confirmModel;
   

    const handleClose = () => {
        const payload = { ...confirmModel, show:false };
        setConfirmModel(payload);
    } 
    return(
        <Modal show={!!show} onHide={handleClose} centered>
            <Modal.Header closeButton>
            <Modal.Title>{ title }</Modal.Title>
            </Modal.Header>
            <Modal.Body>{ text }</Modal.Body>
            <Modal.Footer>
            <Button variant="outline-secondary" onClick={handleClose}>
                { cancelButtonText }
            </Button>
            <Button variant="danger" onClick={successCallback}>
                { successButtonText }
            </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default ConfirmModel;
